var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65677 19.0161C6.38729 19.7458 7.57165 19.7445 8.3026 19.0153L15.8206 11.4956L15.821 15.5609C15.8214 16.662 16.6583 17.5555 17.6921 17.5564C18.7242 17.5547 19.5624 16.6624 19.5628 15.5604L19.562 7.06956C19.5637 5.96712 18.7259 5.0736 17.6917 5.07402C17.6651 5.07574 17.6407 5.08132 17.6145 5.0826C17.5785 5.08175 17.5442 5.07231 17.5064 5.07145L9.1305 5.07231C8.04351 5.07317 7.16328 5.9105 7.16371 6.94387C7.16371 7.97767 8.04522 8.81457 9.13136 8.81629L13.2104 8.81586L5.65677 16.3694C4.92539 17.1 4.92496 18.2843 5.65677 19.0161Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.51c73fa2ebc37bc8fb59a055de312e3a.svg";
export { ForwardRef as ReactComponent };